/**
 * Header 5016 — KUK promotional marquee.
 *
 * A tinted bar carrying one line of promotional copy that scrolls continuously.
 * Ported from the strip at the top of kuk-campus-portal's
 * `components/Landing/Hero.tsx`, where it lives inside the hero and so cannot be
 * reordered, hidden or reworded on its own.
 *
 * Every field maps to a column that already exists on `header` — the variant
 * adds no schema of its own beyond widening `header.variant`.
 *
 * COLUMN MAPPING — the optional backdrop texture is stored in `logo` /
 * `logo_alt_text`, the only image pair on `header` this variant does not
 * otherwise use. Documented because the name says "logo" and it is not one.
 */

export const HEADER_5016_CONSTANTS = {
  HEADER_FIELDS_CONFIG: [
    {
      fieldName: "promotional_text",
      label: "Marquee text",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      rows: 2,
      placeholder: "e.g. Admissions closing soon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "promotional_text_color",
      label: "Text colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "promotional_text_bg_color",
      label: "Bar background",
      value: "rgba(181, 32, 60, 0.80)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(181, 32, 60, 0.80)",
      description: "RGBA, not COLOR: the reference lays a brand colour over the page at 80% opacity.",
      required: false,
      defaultValue: "rgba(181, 32, 60, 0.80)",
    },
    {
      fieldName: "auto_scroll_speed",
      label: "Seconds per pass (ms)",
      value: 20000,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "20000",
      description: "Milliseconds for one full pass. Higher is slower. Motion is disabled for visitors who ask for reduced motion.",
      required: false,
      defaultValue: 20000,
    },
    {
      fieldName: "logo",
      label: "Backdrop texture",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — a decorative image behind the tint",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "logo_alt_text",
      label: "Backdrop alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "sticky_to_top",
      label: "Stick to the top of the page",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "show_on_mobile",
      label: "Show below 768px",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: true,
    },
  ],
};
